import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import BaseModal from './BaseModal.js';
import { jsx } from 'react/jsx-runtime';
import useIsMobile from '../../hooks/useIsMobile.js';
import DraggableDrawer from '../DraggableDrawer/DraggableDrawer.js';

var _excluded = ["isOpen", "onClose", "nonClosable", "children", "heading", "headerContent", "size", "initialIsMobile"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    nonClosable = _ref.nonClosable,
    children = _ref.children,
    heading = _ref.heading;
    _ref.headerContent;
    var size = _ref.size,
    initialIsMobile = _ref.initialIsMobile,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useIsMobile(initialIsMobile);
  var renderDraggableDrawer = isMobile;
  return renderDraggableDrawer ? /*#__PURE__*/jsx(DraggableDrawer, _objectSpread(_objectSpread({
    heading: heading,
    show: isOpen,
    onClose: onClose,
    nonClosable: nonClosable,
    defaultHeight: 85
  }, rest), {}, {
    children: children
  })) : /*#__PURE__*/jsx(BaseModal, _objectSpread(_objectSpread({
    isOpen: isOpen,
    heading: heading,
    onClose: onClose,
    nonClosable: nonClosable,
    size: size
  }, rest), {}, {
    children: children
  }));
};
Modal.defaultProps = {
  isOpen: true,
  onClose: function onClose() {},
  nonClosable: false,
  heading: null,
  headerContent: null,
  size: 'm',
  initialIsMobile: undefined
};
var Modal$1 = Modal;

export { Modal$1 as default };
//# sourceMappingURL=Modal.js.map
